import { Component, OnInit, Input } from "@angular/core";
import { StateService } from "src/app/services/state.service";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"]
})
export class DashboardComponent implements OnInit {
  constructor(public _state: StateService) {}

  ngOnInit(): void {
    // this._state.validateLogin();
  }
}
